import { render, staticRenderFns } from "./commodityManagement.vue?vue&type=template&id=a4eb4878&scoped=true"
import script from "./commodityManagement.vue?vue&type=script&lang=js"
export * from "./commodityManagement.vue?vue&type=script&lang=js"
import style0 from "./commodityManagement.vue?vue&type=style&index=0&id=a4eb4878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eb4878",
  null
  
)

export default component.exports